import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { catchError, of } from 'rxjs';
import { DistrictAdminService } from '../../../../services/district-admin.service';
import { School } from '../../../../models/school';
import { User } from '../../../../models/user';
import { UserAvatar } from '../../../common/user-avatar/user-avatar';

export interface DistrictStaffDialogData {
  s: School;
}

@Component({
  selector: 'app-district-staff',
  imports: [CommonModule, MatDialogModule, UserAvatar],
  templateUrl: './district-staff.html',
  styleUrl: './district-staff.css',
})
export class DistrictStaff {
  private districtAdminService: DistrictAdminService = inject(DistrictAdminService);
  private dialogRef: MatDialogRef<DistrictStaff> = inject(MatDialogRef);
  data: DistrictStaffDialogData = inject(MAT_DIALOG_DATA);
  error = false;

  staff$: Observable<User[] | null> = this.districtAdminService.getSchoolStaff(this.data.s.id).pipe(
    catchError((err) => {
      console.error(err);
      this.error = true;
      return of(null);
    }),
  );

  /**
   * Returns users initals
   * @param {User} s
   * @returns {string} initals
   */
  initials(s: User): string {
    const f = s.firstName?.[0] ?? '';
    const l = s.lastName?.[0] ?? '';
    return (f + l).toUpperCase();
  }

  /**
   * Returns role with uppercase first letter or unkown
   * @param {string} role
   * @returns {string} role
   */
  roleLabel(role: string): string {
    if (!role) return 'Unknown';
    return role.charAt(0).toUpperCase() + role.slice(1);
  }

  close(): void {
    this.dialogRef.close();
  }
}
